import { FunctionsHttpError } from "@supabase/supabase-js";

export const handleSupabaseError = async (
  error: unknown,
  setError: React.Dispatch<React.SetStateAction<any>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    setError(errorMessage.error);
    setIsLoading(false);
  }
};
